/* ==========================================================================
   CART TIER NUDGE — click handler (asset version)
   ==========================================================================
   Loaded once from layout/theme.liquid (after global.bundle.js, deferred).
   Wires a single delegated click handler on `document`. Independent of
   cart-tier-nudge.liquid rendering state, which is critical because the
   theme uses Alpine.morph() to swap cart-items HTML — and Alpine.morph
   does NOT execute <script> tags found inside morphed content. The old
   inline script lived inside the `{% if suggest_handle != '' %}` block,
   so on pages where the nudge was hidden at first paint (e.g. cart already
   at top tier), the handler was never wired. When customers later removed
   items and the nudge appeared via morph, the script in the morphed HTML
   was skipped — leaving a visible button with no listener.

   Loading from theme.liquid sidesteps that entirely.

   Pattern (canonical Shapes theme — verified in global.bundle.js ~line 980):
     1. POST /cart/add.js with sections=cart-items,cart-footer,cart-item-count,cart-live-region
     2. Dispatch shapes:cart:afteradditem on window with { detail: { response } }
     3. Theme listeners morph cart-items + cart-footer in place

   Last meaningful edit: 2026-05-11 (extracted to asset to fix mobile remove bug)
   ========================================================================== */

(function () {
  // ---------- Persistent log buffer (devtools: __unspunLog.dump()) ----------
  if (!window.__unspunLog) {
    var KEY = 'unspun-cart-logs';
    var MAX = 200;
    function getLogs() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
    function setLogs(arr) { try { localStorage.setItem(KEY, JSON.stringify(arr.slice(-MAX))); } catch (e) {} }
    window.__unspunLog = function (event, data) {
      var entry = { t: new Date().toISOString(), event: event, data: data || null };
      var logs = getLogs(); logs.push(entry); setLogs(logs);
      console.log('[unspun]', event, data || '');
    };
    window.__unspunLog.dump = function () { console.table(getLogs()); return getLogs(); };
    window.__unspunLog.clear = function () { localStorage.removeItem(KEY); console.log('[unspun] logs cleared'); };
    window.__unspunLog('log buffer initialised — call __unspunLog.dump() to view');
  }

  // ---------- One-time wire ----------
  if (window.__unspunNudgeWiredV8) return;
  window.__unspunNudgeWiredV8 = true;

  // ---------- Delegated click handler ----------
  // Capture phase + stopPropagation so the theme's native form handler
  // doesn't fire alongside ours.
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-cart-tier-nudge-add]');
    if (!btn || btn.dataset.busy) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    var handle = btn.getAttribute('data-product-handle');
    window.__unspunLog('click', { variantId: variantId, handle: handle });

    // Fallback: if no variant ID (shouldn't happen), send to PDP
    if (!variantId) {
      window.location.href = '/products/' + handle;
      return;
    }

    btn.dataset.busy = '1';
    var orig = btn.innerHTML;
    btn.innerHTML = 'Adding…';
    btn.style.opacity = '0.6';

    try {
      window.__unspunLog('POST /cart/add.js with sections');
      var resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: parseInt(variantId, 10),
          quantity: 1,
          sections: 'cart-items,cart-footer,cart-item-count,cart-live-region',
          sections_url: window.location.pathname
        })
      });
      window.__unspunLog('response received', { status: resp.status });
      if (!resp.ok) {
        var errBody = await resp.text();
        window.__unspunLog('error body', { body_preview: errBody.substring(0, 200) });
        throw new Error('add-' + resp.status);
      }
      var data = await resp.json();
      window.__unspunLog('response parsed', {
        has_sections: !!data.sections,
        section_keys: data.sections ? Object.keys(data.sections) : []
      });

      // Hand off to the theme — its listeners morph cart-items + cart-footer.
      // The entire nudge will be replaced by the morphed cart-items HTML.
      window.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', {
        detail: { response: data, sourceId: 'cart-tier-nudge' }
      }));
      window.__unspunLog('shapes:cart:afteradditem dispatched — theme should morph cart now');

      // Reset (the DOM is about to be replaced by the morph anyway)
      btn.dataset.busy = '';
      btn.innerHTML = orig;
      btn.style.opacity = '';
    } catch (err) {
      window.__unspunLog('FAILED', { error: String(err) });
      btn.dataset.busy = '';
      btn.innerHTML = orig;
      btn.style.opacity = '';
      // Last-resort fallback: send to PDP so customer can add manually
      window.location.href = '/products/' + handle + '?variant=' + variantId;
    }
  }, true);

  window.__unspunLog('cart-tier-nudge.js v8 wired (loaded as asset from theme.liquid)');
})();
